import { IAssetSummary } from "../api/fetchMaintenance";
import { Asset, AssetModel } from "../models/asset";

export const getAssetIdByChassis = (assets: any[], chassis: string): string | undefined => {
  return assets
    .find((asset) => asset.chassis === chassis)?.id;
}

export const getAssetIdsByChassisList = (assets: any[], chassisList: string[]): string[] => {
  return assets
    .filter((asset) => chassisList.includes(asset.chassis))
    .map((asset) => asset.id);
}

export const getAssetIdsByChassisListFromAssetSummary = (assets: IAssetSummary[], chassisList: string[]): string[] => {
  return assets
    .filter((asset) => chassisList.includes(asset.identification))
    .map((asset) => asset.id);
}

export const getChassisListFromAssetIds = (allAssets: Asset[], assetIds: string[]): string[] => {
  if(allAssets.length === assetIds.length) return [];
  
  return allAssets
    .filter((asset) => assetIds.includes(asset.id))
    .map((asset) => asset.chassis);
}

export const getChassisFromAssetName = (allAssets: Asset[], assetNames: string[]): string[] => {
  return allAssets
    .filter((asset) => assetNames.includes(asset.name))
    .map((asset) => asset.chassis);
}

export const getAssetModelToSelectOption = (id?: string, assetModels?: AssetModel[]) => {
  if(!id) return null;

  // Check if id is a UUID
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  if (uuidRegex.test(id)) {
    return assetModels?.find((model) => model.modelId === id) || null;
  }

  return { modelCode: id, description: id };
};